import { EnvironmentModel } from '@b2c/services/common';

export const environment: EnvironmentModel = {
  production: true,
  serviceEndPoint: 'https://webapi-test.musetrip.com',
  analytics: {
    google: {
      measureId: 'G-7YK901BKB6',
      adLabels: [
        {
          // cps
          id: 'AW-10903515688',
          label: 'P-yvCIaB1L8DEKjkmc8o',
        },
        {
          // cpc
          id: 'AW-10903575227',
          label: 'yN-0CMmg39kDELu1nc8o',
        },
      ],
    },
    skyscanner: {
      parterId: 'h_dd',
    },
  },
};
